import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentComments } from '../requests';
import type { GetDocumentRequestType } from '../types';

export const useGetDocumentComments = (
  documentId?: GetDocumentRequestType['documentId'],
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.documentComments, { documentId }],
    queryFn: () => getDocumentComments({ documentId: documentId! }),
    enabled: !!documentId,
  });
